import { render, staticRenderFns } from "./SubEventsPanel.vue?vue&type=template&id=bcfcc3da&scoped=true"
import script from "./SubEventsPanel.vue?vue&type=script&lang=js"
export * from "./SubEventsPanel.vue?vue&type=script&lang=js"
import style0 from "./SubEventsPanel.vue?vue&type=style&index=0&id=bcfcc3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfcc3da",
  null
  
)

export default component.exports